<template>
	<div>
		<a-modal :title="getTitle" :width="800" :visible="visible" @cancel="handleCancel">
			<template slot="footer">
				<a-button key="back" @click="handleCancel">
					取消
				</a-button>
				<a-button key="submit" type="primary" @click="onSubmit" :loading="confirmLoading">
					保存
				</a-button>
			</template>
			<a-spin :spinning="loading">
				
					<div>
						<div class="flex alcenter">
							<div class="ft14 ftw400 cl-info">头像：</div>
							<div class="ft12 ftw400 cl-notice ml8">建议上传200x200px</div>
						</div>
						<div class="flex center mt10">
							<upload-img v-model="form.face" ></upload-img>
						</div>
					</div>
				
					<div class="flex  mt10">
						<a-input class="woyaou-input" style="width: 230px;" prefix="姓名" placeholder="请输入姓名" v-model="form.name" :maxLength="20">
						</a-input>
						<a-input class="woyaou-input ml20" prefix="手机号" style="width: 230px;" placeholder="请输入手机号" v-model="form.mobile" :maxLength="20">
						</a-input>
					</div>
					
					<div class="flex  mt10">
						<a-input class="woyaou-input" style="width: 230px;" prefix="工龄" placeholder="请输入工龄" v-model="form.working_collar" :maxLength="20">
						</a-input>
						<a-input class="woyaou-input ml20" prefix="工号" style="width: 230px;" placeholder="请输入工号" v-model="form.job_number" :maxLength="20">
						</a-input>
					</div>
					
					<div class="flex  mt10">
						<a-input class="woyaou-input" style="width: 230px;" prefix="职位" placeholder="请输入职位" v-model="form.position" :maxLength="20">
						</a-input>
						<a-input class="woyaou-input ml20" prefix="排序" style="width: 230px;" placeholder="请输入序号" v-model="form.sort" :maxLength="20">
						</a-input>
					</div>

					<div class="flex alcenter mt20">
						<div class="ft14 ftw500 cl-info">等级</div>
						<div style="width: 230px; margin-left: 10px;">
							<a-select style="width: 200px;" v-model="form.level">
								<a-select-option :value="1">资深治疗师</a-select-option>
								<a-select-option :value="2">总监治疗师</a-select-option>
								<a-select-option :value="3">专家治疗师</a-select-option>
							</a-select>
						</div>
					</div>

					<div class="flex alcenter mt20">
						<div class="ft14 ftw500 cl-info">所属门店</div>
						<div style="width: 200px; margin-left: 10px;">
							<a-select style="width: 200px;" v-model="form.mendian_id">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option v-for="(item,index) in mendians" :key="index" :value="item.mendian_id">{{item.name}}</a-select-option>
							</a-select>
						</div>
					</div>
					
					<div class="mt20">
						<div class="flex alcenter">
							<div class="ft14 ftw500 cl-info">简介</div>
							<div class="ft12 ftw400 cl-notice ml8">200字以内</div>
						</div>
						<div class="flex center mt10">
							<a-textarea placeholder="请输入简介内容" v-model="form.brief_introduction" :rows="4" :maxLength="200"/>
						</div>
					</div>

					<div class="mt20">
						<div class="flex alcenter">
							<div class="ft14 ftw500 cl-info">详情</div>
							<!-- <div class="ft12 ftw400 cl-notice ml8">200字以内</div> -->
						</div>
						<div class="flex center mt10">
							<html-edit v-model="form.content"></html-edit>
						</div>
					</div>
			</a-spin>
		</a-modal>
	</div>
</template>

<script>
	import uploadImg from '../../../../../components/upload/upload.vue'
	import  htmlEdit from '../../../../../components/html.vue';
	export default {
		props: {
			visible: {
				type: Boolean,
				default: false,
			},
			technician_id: {
				type: Number,
				default: 0
			},
		},
		components:{
			uploadImg,
			htmlEdit
		},
		data() {
			return {
				loading: false,
				confirmLoading: false,
				form: {
					name: '',
					face:'',
					mobile: '',
					position:'',
					mendian_id: 0,
					working_collar: '',
					job_number: '',
					brief_introduction: '',
					level:1,
					content:'',
					sort:0
				},
				mendians:[]
			}
		},
		computed: {
			getTitle() {
				if (this.technician_id == 0) {
					return "添加"+this.artificer;
				} else {
					return "编辑"+this.artificer
				}
			}
		},
		created() {
			this.loaddata();
			this.getMendians();
		},
		methods: {
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			loaddata(){
				if(this.technician_id==0) return;
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/showTechnician',{
					technician_id:this.technician_id,
				}).then(res=>{
					if(res.form){
						this.form=res.form;
					}
					this.loading=false;
				}).catch(res=>{
					console.log(res);
					this.loading=false;
					this.$router.go(-1);
				})
			},
			
			/**
			 * 取消弹窗
			 */
			handleCancel() {
				this.$emit("cancel");
			},

			/**
			 * 提交数据
			 */
			onSubmit() {

				if(this.form.name === ''){
					this.$message.success('请填写姓名');
					return;
				}

				if(this.form.mobile === ''){
					this.$message.success('请填写手机号');
					return;
				}

				if(this.form.mendian_id === 0){
					this.$message.success('请选择门店');
					return;
				}

				if(this.confirmLoading==true) return;
				this.confirmLoading=true;
				this.$http.api('admin/saveTechnician',{
					technician_id:this.technician_id,
					name:this.form.name,
					mobile:this.form.mobile,
					face:this.form.face,
					position:this.form.position,
					mendians:this.form.position,
					working_collar:this.form.working_collar,
					job_number:this.form.job_number,
					brief_introduction:this.form.brief_introduction,
					mendian_id:this.form.mendian_id,
					level:this.form.level,
					content:this.form.content,
					sort:this.form.sort,
				}).then(res=>{
					this.$message.success('保存成功',1,()=>{
						this.confirmLoading=false;
						this.$emit('ok');
					})
					
				}).catch(res=>{
					console.log(res);
					this.confirmLoading=false;
				})
			},

		}

	}
</script>

<style>
	
</style>
